<template>
	<div :class="['step-two', {'mb-3': isActive && activeStep > 1}]">
		<stepHeader
			:msg="getDeliveryText"
			:currentStep="2"
			:maxStep="4"
			:useSubtitle="useSubtitle"
			:useBackgroundColor="useBackgroundColor"
		/>
		<div v-show="firstTimeDisplay && deliveryOption > 0 || isActive && activeStep > 1 && (selectedShippingMethodId || selectedStoreId)">
			<!-- Remove temporarily -->
			<!-- <div
				v-if="partialDeliveryAvailable && this.isActive"
				class="check-partial-delivery"
			>
				<checkbox
					v-model="pickedPartialDelivery"
					small
					label="Jag tar gärna emot flera separata leveranser om det gör att jag får produkterna snabbare."
				/>
				<hr />
			</div> -->

			<zipCodeSelector
				v-if="isActive && activeStep > 1"
				@updateZip="setZipCode"
				:zipCode="selectedZipCode"
				ref="zipSelector"
				:deliveryOption="deliveryOption"
				@setLocation="setLocation"
			/>

			<!-- Eol info -->
			<div
				v-if="shippingSiteInfo.hasEolProducts && isActive && hasEolDeliveryIssues['deliveryOption' + deliveryOption]"
				class="alert alert-danger eol-info"
			>
				<template v-for="eolInfo of stockAvailability.eolRelatedDeliveryIssues">
					<template v-if="eolInfo.deliveryOption === deliveryOption && eolInfo.products.length">
						<template v-if="eolInfo.translation === 'BULKY'">
							{{ te('BULKY_INFO') }}
							<hr>
						</template>
						{{ te(eolInfo.translation) }}
					</template>
					<ul
						v-if="eolInfo.deliveryOption === deliveryOption && eolInfo.products.length"
						class="eol-list"
					>
						<li
							v-for="product of eolInfo.products"
							class="eol-product"
						>
							<template v-if="deliveryOption === 2">
								{{ product }}
							</template>
							<template v-else>
								<b>{{ product }}:</b>
								<span v-for="store of shippingSiteInfo.eolStockPlaces[product] ">
									{{ storeName(store) }}
								</span>
							</template>
						</li>
					</ul>
				</template>
			</div>

			<checkoutStoreSelector
				v-if="deliveryOption === 1  && activeStep > 1"
				:cartRows="cart.rows"
				:value="selectedStoreId"
				:isActive="isActive && activeStep > 1"
				:location="location"
				:selectedZipCode="selectedZipCode"
				:stepSelection.sync="stepSelection"
				:limitedByEol="shippingSiteInfo.hasEolProducts"
				:eolStockPlaces="shippingSiteInfo.eolStockPlaces"
				:eolProducts="stockAvailability.eolRelatedDeliveryIssues.specificStorePickup.products"
				@update:selectedStoreId="v => $emit('update:selectedStoreId', v)"
				@storeStock="setStoreStock"
			/>

			<div class="col-xs-12 ship-from-store" v-if="numberOfProductsSentFromStore > 0 && selectedZipCode && canShipNow && deliveryOption === 2 && isActive">
				<h3>Skickas direkt</h3>
				<p>Dina produkter skickas direkt från en butik.</p>
			</div>

			<loading-spinner v-if="deliveryOption === 2 && isActive && ! hasFetchedShippingMethods" />
			<template v-if="imiGoShippingMethods.length">
				<shippingMethod
					v-show="deliveryOption === 2 && parseInt(selectedZipCode) > 0 && ! changingZipCode && (isActive || selectedShippingMethodId) && activeStep > 1"
					class="list-group col-xs-12"
					:imiGoShippingMethods="imiGoShippingMethods"
					:shippingPriceMap="shippingPriceMap"
					:testConstraint="testConstraint"
					:selectedZipCode="selectedZipCode"
					:stockAvailability="stockAvailability"
					:selectedShippingMethodId="selectedShippingMethodId"
					:selectedShippingOption="selectedShippingOption"
					:isActive="isActive && activeStep > 1"
					:activeStep="activeStep"
					@update:selectedShippingMethodId="v => $emit('update:selectedShippingMethodId', v)"
					@update:selectedShippingOption="v => $emit('update:selectedShippingOption', v)"
					@update:highestPackageSizeId="v => $emit('update:highestPackageSizeId', v)"
					:cart="cart"
					:user="user"
					:isCorporateCustomer="isCorporateCustomer"
					:mostExpensiveProductInCart="mostExpensiveProductInCart"
					:numberOfProductsSentFromStore="numberOfProductsSentFromStore"
					:isAllProductsSentFromStore="isAllProductsSentFromStore"
					:firstShippingMethod="true"
					:canShipNow="canShipNow"
					:stepSelection.sync="stepSelection"
					:isDownload="isDownload"
					:weight="weight"
					:volume="volume"
					:involvesShipFromStore="shippingSiteInfo.involvesShipFromStore"
				/>

				<div class="col-xs-12 ship-from-store" v-if="numberOfProductsSentFromStore > 0 && selectedZipCode && canShipNow && deliveryOption === 2 && isActive && ! isCorporateCustomer">
					<h3>Skickas senare</h3>
					<p>Med dessa leveranssätt behöver vi vänta in dina produkter till vårt centrallager.</p>
				</div>
				<shippingMethod
					v-if="numberOfProductsSentFromStore > 0 && canShipNow"
					v-show="deliveryOption === 2 && parseInt(selectedZipCode) > 0 && ! changingZipCode && (isActive || selectedShippingMethodId) && activeStep > 1"
					class="list-group col-xs-12"
					:imiGoShippingMethods="imiGoShippingMethods"
					:shippingPriceMap="shippingPriceMap"
					:testConstraint="testConstraint"
					:selectedZipCode="selectedZipCode"
					:stockAvailability="stockAvailability"
					:selectedShippingMethodId="selectedShippingMethodId"
					:selectedShippingOption="selectedShippingOption"
					:isActive="isActive && activeStep > 1"
					:activeStep="activeStep"
					@update:selectedShippingMethodId="v => $emit('update:selectedShippingMethodId', v)"
					@update:selectedShippingOption="v => $emit('update:selectedShippingOption', v)"
					@update:highestPackageSizeId="v => $emit('update:highestPackageSizeId', v)"
					:cart="cart"
					:user="user"
					:isCorporateCustomer="isCorporateCustomer"
					:mostExpensiveProductInCart="mostExpensiveProductInCart"
					:numberOfProductsSentFromStore="numberOfProductsSentFromStore"
					:isAllProductsSentFromStore="isAllProductsSentFromStore"
					:firstShippingMethod="false"
					:canShipNow="canShipNow"
					:stepSelection.sync="stepSelection"
					:weight="weight"
					:involvesShipFromStore="shippingSiteInfo.involvesShipFromStore"
				/>
			</template>

			<text-button
				v-if="isActive"
				class="continue-btn"
				text="Fortsätt"
				:disabled="! showContinueButton"
				@click="finished"
			/>
		</div>
		<ship-from-store-popup
			v-if="showShipFromStorePopup && ! isCorporateCustomer"
			ref="shipFromStorePopup"
			@continue="finished"
			@changeToPostnord="changeToPostnord"
		/>
	</div>
</template>

<script>
import bus from 'eventbus';
import { debounce } from 'lodash';
import stepHeader from './step-header';
import checkoutStoreSelector from './checkout-store-selector';
import shippingMethod from './shipping-method';
import zipCodeSelector from './zip-code-selector';
import localSessionStorage from 'localSessionStorage';
import stockUtils from 'utils/stock';
import { daysBetweenDates, calculatePackageData } from 'utils';
import { getMostExpensiveProduct } from 'utils/cart';
import { mapState, mapGetters } from 'vuex';
import { storeName } from 'datastore/i18n';
import { t } from 'datastore/i18n';

export default {
	props: {
		stockMap: {},
		selectedShippingMethodId: {
			type: Number,
			required: false,
			default: 0,
		},
		selectedShippingOption: {},
		testConstraint: {
			type: Function,
		},
		updateOrderFlags: {
			type: Function,
		},
		isCorporateCustomer: {
			type: Boolean,
			required: true,
		},
		isActive: {
			type: Boolean,
			required: false,
		},
		activeStep: {
			type: Number,
		},
		predefinedCart: {
			type: Object,
			default: null,
		},
		orderTotalSum: {
			type: Number,
			default: null,
		},
		cartSum: {
			type: Number,
			default: null,
		},
		weight: {
			type: Number,
			default: null,
		},
		volume: {
			type: Number,
			default: null,
		},
		selectedStoreId: {
			type: Number,
			default: null,
		},
	},
	data() {
		return {
			changingZipCode: false,
			deliveryOption: 0,
			selectedZipCode: 0,
			location: {},
			firstTimeDisplay: false,
			pickedPartialDelivery: false,
			storeStock: null,
			stepSelection: '',
			imiGoShippingMethods: [],
			isDownload: false,
			hasFetchedShippingMethods: false,
			returningFromBriqpay: false,
		};
	},
	components: {
		stepHeader,
		zipCodeSelector,
		shippingMethod,
		checkoutStoreSelector,
	},
	beforeMount() {
		if (! this.splittableShippingOptions.length) {
			this.$store.dispatch('shippingMethodRelatedInfo/getShippingMethodRelatedInfo');
		}
	},
	mounted () {
		let checkoutData = localSessionStorage.get('checkoutData');
		if (checkoutData) {
			checkoutData = JSON.parse(checkoutData);
		}

		if (checkoutData && checkoutData?.returningFromBriqpay) {
			this.firstTimeDisplay = true;
			this.returningFromBriqpay = true;
			this.setDeliveryOption(checkoutData.isStoreReservation ? 1 : 2);
			this.setZipCode(checkoutData.cutomerInfoData.zip_code);
			if (checkoutData.isStoreReservation) {
				this.$emit('update:selectedStoreId', checkoutData.selectedStoreId);
			}
		} else {
			this.setDeliveryOption(2);
			this.getShippingMethods();
		}

		bus.$on('deliveryOptionChanged', this.setDeliveryOption);
		bus.$on('stepOneReverseComplete', this.startStepOne);
		bus.$on('update:zip', this.setZipCode);
	},
	beforeDestroy () {
		bus.$off('stepOneReverseComplete', this.startStepOne);
		bus.$off('deliveryOptionChanged', this.setDeliveryOption);
		bus.$off('update:zip', this.setZipCode);
	},
	methods: {
		storeName,
		t,
		te: t.prefix('EOL'),
		debouncedGetShippingMethods: debounce( function () {
			this.getShippingMethods();
		}, 333, { leading: false, trailing: true }),
		getShippingMethods () {
			this.hasFetchedShippingMethods = false;
			if (this.selectedZipCode) {
				const data = {
					postalCode: this.selectedZipCode,
					filters: {
						order_value: this.cartSum,
						chargeable_weight: Math.max(this.packageData.volumeWeight, this.packageData.weight),
						customer_rank_level: this.user.rankLevel,
						has_digital_products: this.isDownload,
						involves_ship_from_store: this.shippingSiteInfo.involvesShipFromStore,
						is_corporate_customer: this.isCorporateCustomer,
						is_in_stock: (this.shippingSiteInfo.hasStock?.length || this.shippingSiteInfo.involvesShipFromStore) ,
						shipping_class: this.mostExpensiveProductInCart.shippingClass.id,
						order_weight: this.packageData.weight,
						order_volume: this.packageData.volume,
						max_length: this.packageData.maxLongest,
						max_middle: this.packageData.maxMiddle,
						max_shortest: this.packageData.maxShortest,
						max_sides_sum: this.packageData.maxSidesSum,
						max_longest_plus_c: this.packageData.maxLongestPlusC,
						volumetric_weight: this.packageData.volumeWeight,
						zip_code: this.selectedZipCode.toString(),
					}
				};

				waja.post('shipping-methods')
					.data(data)
					.on('success', res => {
						this.imiGoShippingMethods = res.data;
						this.hasFetchedShippingMethods = true;
					}).go();
			}
		},
		finished (value) {
			if (this.numberOfProductsSentFromStore > 0 && ! this.isCorporateCustomer && ! this.splittableShippingOptions.includes(this.selectedShippingMethodId) && value != 'ship-later' && ! this.selectedStoreId) {
				if (! this.isDownload) {
					this.triggerShipFromStore();
					return;
				}
			}

			const stepValue = this.deliveryOption === 1 ? this.selectedStoreId : this.selectedShippingMethodId;

			this.$emit('stepUpdated', 3, stepValue);
		},
		setDeliveryOption (option) {
			this.deliveryOption = option;

			switch (option) {
				case 0:
					this.$emit('storeReservationUpdated', null);
					break;
				case 1: /* Store */
					this.$emit('storeReservationUpdated', true);
					this.$emit('update:selectedShippingMethodId', 4);
					break;
				case 2: /* Delivery */
					this.$emit('stockAvailability', this.stockAvailability.inWebStock && ! this.stockAvailability.releaseDate);
					this.$emit('storeReservationUpdated', false);
					this.$emit('update:selectedShippingMethodId', null);
					break;
				default:
					break;
			}
		},
		setZipCode(zipCode) {
			this.selectedZipCode = parseInt(zipCode);
			if (! this.returningFromBriqpay) {
				this.getShippingMethods();
			}
		},
		setLocation (location) {
			this.$emit('update:selectedStoreId', null);
			this.location = location;
			this.$nextTick(() => {
				bus.$emit('selectFirstStore', null);
			});
		},
		setStoreStock (value) {
			this.storeStock = value;
		},
		triggerShipFromStore () {
			if (this.showShipFromStorePopup) {
				this.$refs.shipFromStorePopup.modalOpen = true;
			}
		},
		changeToPostnord () {
			this.$emit('update:selectedShippingMethodId', 1);
		},
		isStoreRestrictedByShippingSite(storeId) {
			return this.hasUnrestrictedShipping.indexOf(storeId ? storeId : this.reSupplyPointId) < 0;
		},
		isBulkyProduct (productSize) {
			return productSize > 2;
		},
		/**
		 * This method checks:
		 * if a product has any EOL places
		 * AND (no web stock
		 * OR web stock but only in store)
		 * @TODO move out qty check
		 */
		productCanOnlyShipFromStore (cartRow) {
			return this.shippingSiteInfo.eolStockPlaces?.[cartRow.product.id]
				&& (! this.shippingSiteInfo.eolStockPlaces?.[cartRow.product.id].includes('web')
				|| (this.shippingSiteInfo.eolStockPlaces?.[cartRow.product.id].includes('web')
				&& ! Object.keys(cartRow.product.stock.webStock).some(storeId => ! cartRow.product.stock.hasOwnProperty(storeId) && cartRow.product.stock.webStock[storeId] && cartRow.quantity <= cartRow.product.stock.webStock[storeId])));
		},
		isHeavy(weight, quantity) {
			return weight > (quantity > 1 ? 18 : 20);
		}
	},
	computed: {
		waitForBriqpay () {
			return !! this.returningFromBriqpay && !! this.cartSum && !! this.shippingSiteInfo?.shippingSiteId;
		},
		isBulkyCart () {
			return this.cart.rows.some(row => this.isBulkyProduct(row.product.packageSizeId));
		},
		isAwkwardStoreShip () {
			return this.isBulkyCart || this.isHeavy(this.packageData.weight, this.cart.rows.length) && ! this.isCorporateCustomer;
		},
		shippingSiteInfo () {
			let storeMap = {
				'hasStock': [...this.shippingStoresByPrioOrder], //Getting store ids for active warehouses
				// 'rows': {},
				'shippingSiteId': '',
				'isLimitedByShippingSite': true,
				'involvesShipFromStore': false,
				'hasEolProducts': false,
				'eolStockPlaces': {},
			};

			if (! (this.shippingStoresByPrioOrder && this.reSupplyPointId && this.horizonEnabled !== null)) {
				return {};
			}

			let split = {};
			let unstocked = false;
			this.cart.rows.forEach(row => {
				let storeId = null;
				if (row.product.stock.webStock) {
					for (let store of this.shippingStoresByPrioOrder) {
						let stock = row.product.stock.webStock[store];
						if ((! stock || stock < row.quantity) && storeMap.hasStock.indexOf(store) >= 0) {
							storeMap.hasStock.splice(storeMap.hasStock.indexOf(store), 1); //excluding warehouses where orderrow not in stock
						} else if (! storeId && this.horizonEnabled) {
							storeId = store;
						}
					}
				} else if (row.product.stock.download) {
					storeMap.hasStock = [this.reSupplyPointId];
				}
				unstocked = unstocked || ! storeId ? true : false;
				storeId = storeId ? storeId : this.reSupplyPointId;
				split[storeId] = storeId;
				/**
				 * looks for discontinued products and creates object
				 * with store id arryas where the product is in stock
				 */
				if (row.product.discontinued > 0) {
					storeMap.hasEolProducts = true;
					storeMap.eolStockPlaces[row.product.id] = Object.keys(row.product.stock).filter(( key ) => {
						return row.quantity <= row.product.stock[key] && key !== 'displayCap';
					});
				}
			});

			storeMap.shippingSiteId = (storeMap?.hasStock?.length ? storeMap.hasStock[0] : this.reSupplyPointId).toString();
			storeMap.isLimitedByShippingSite = this.isStoreRestrictedByShippingSite(storeMap.shippingSiteId * 1);

			if (! storeMap.hasStock.length && Object.keys(split).length > 1) {
				if (! storeMap.hasEolProducts && unstocked) {
					split = {[storeMap.shippingSiteId]: storeMap.shippingSiteId};
				} else {
					storeMap.isLimitedByShippingSite = true;
				}
			}
			let stockItems = this.cart.rows[0].product.stock;
			//if any of the chosen stores matches a object key outside of the webstock array, that means shipFromStore is an option
			storeMap.involvesShipFromStore = this.isAwkwardStoreShip && ! storeMap.hasEolProducts ? false : storeMap.hasStock.length && stockItems[storeMap.shippingSiteId] >= 0 || Object.keys(split).some(itemId => stockItems[itemId] >= 0);

			return storeMap;
		},
		packageData () { //ta in en array
			return calculatePackageData(this.cart.rows);
		},
		packageMeasurement () {
			let measurement = 0;
			for (const row of this.cart.rows) {
				const measure = row.product.packageMeasurements.reduce((acc, curr) => {
					return acc + curr
				});
				measurement += measure * row.quantity;
			}
			return measurement
		},
		includeBoxes () {
			for (const row of this.cart.rows) {
				const measurements = JSON.parse(JSON.stringify(row.product.packageMeasurements));
				const max = Math.max(...measurements);
				const index = measurements.indexOf(max);
				if (index > -1) {
					measurements.splice(index, 1);
				}
				const includeBoxes = max <= 600 && measurements.every(num => num <= 400);
				if (! includeBoxes) {
					return false;
				}
			}
			return true;
		},
		/**
		 * The combined stock availability. Checks the stock for each product in
		 * the cart and combines the results.
		 *
		 * The product that has the least favorable stock conditions will determine
		 * the outcome of the stock availability for the entire cart.
		 *
		 * Each cart row will be iterated, and the following conditions checked:
		 *
		 * 1 Unreleased product => Estimated delivery time of order will be set to the release date
		 * of the product.
		 *
		 * 2 In web stock => Good!
		 *
		 * 3 Web stock due soon => One product will be in web stock soon, therefore
		 * set the estimated delivery time for the entire order to be the estimated
		 * number of days until delivery to CL is due for arrival.
		 *
		 * 4 Out of stock => One product is out of stock, therefore the entire
		 * order is out of stock.
		 */
		stockAvailability () {
			const now = new Date();
			/*
			* The result of merging the stock of each cart row will be stored in
			* this object.
			*/
			const availability = {
				inDigitalStock: undefined,
				// Will result in true/false depending on if CL stock is available.
				inWebStock: undefined,
				// May contain an estimate of number of days until stock is available.
				estimateDays: null,
				// May contain the release date of an unreleased product.
				releaseDate: null,
				// Info for orders with EOL products
				eolRelatedDeliveryIssues: {
					bulky: {
						translation: 'BULKY',
						deliveryOption: 2,
						products: [],
					},
					shipFromStore: {
						translation: 'SHIP_FROM_STORE',
						deliveryOption: 2,
						products: [],
					},
					cantShip: {
						translation: 'CANT_SHIP',
						deliveryOption: 2,
						products: [],
					},
					outOfStock: {
						translation: 'OUT_OF_STOCK',
						deliveryOption: 2,
						products: [],
					},
					specificStorePickup: {
						translation: 'SPECIFIC_STORE_PICKUP',
						deliveryOption: 1,
						products: [],
					},
				},
			};

			/**
			 * Previous returns in code stopped the for loop from
			 * checking every product in cart, so these makes sure
			 * the data is still correct while still checking
			 * all products for data needed for EOL
			 */
			let checkForLoopData = true;
			let checkStockMap = true;
			let checkElseIf = true;

			// If we have no stock map, then return default object.
			if (! Object.keys(this.stockMap).length) {
				checkForLoopData = false;
			}

			for (const row of this.cart.rows) {
				const releaseDate = new Date();
				releaseDate.setTime(row.product.release.timestamp * 1000);

				// EOL related checks
				if (this.shippingSiteInfo.hasEolProducts) {
					// Checks if product is in any web stock
					if (this.shippingSiteInfo.eolStockPlaces?.[row.product.id]
						&& ! this.shippingSiteInfo.eolStockPlaces?.[row.product.id].includes('web')) {
						availability.eolRelatedDeliveryIssues.cantShip.products.push(row.product.id);
					}

					if (this.isAwkwardStoreShip) {
						// Checks for bulky products since they can't be sent from store
						if (this.shippingSiteInfo.involvesShipFromStore && (this.isBulkyProduct(row.product.packageSizeId) || this.isHeavy(row.product.packageWeight, 1))) {
							availability.eolRelatedDeliveryIssues.bulky.products.push(row.product.id);
						}

						if (this.productCanOnlyShipFromStore(row)) {
							availability.eolRelatedDeliveryIssues.shipFromStore.products.push(row.product.id);
						}
					}

					/**
					 * EOL products can't be sent to different stores so they can only
					 * be picked up in the store they're in
					 */
					if (this.productCanOnlyShipFromStore(row)) {
						availability.eolRelatedDeliveryIssues.specificStorePickup.products.push(row.product.id);
					}

					/**
					 * If a non EOL product is out of webstock, or is not released
					 * we can't send that product in the same order as the EOL product
					 */
					if (! row.product.stock.web || daysBetweenDates(releaseDate, now) > 0) {
						availability.eolRelatedDeliveryIssues.outOfStock.products.push(row.product.id);
					}
				}

				// Check if the product is yet to be released.
				if (daysBetweenDates(releaseDate, now) > 0) {
					if (! availability.releaseDate || (availability.releaseDate && releaseDate > availability.releaseDate)) {
						availability.releaseDate = releaseDate;
						availability.inWebStock = false;
					}
					continue;
				}

				if (checkForLoopData && checkStockMap && checkElseIf) {
					const qty = row.quantity;
					const prodId = row.product.id + '';
					const stockMap = this.stockMap[prodId];

					if (! stockMap) {
						// Entry for product in stock map is missing, so the result
						// is that the cart products are not all in stock.
						availability.inWebStock = false;
						availability.inDigitalStock = false;
						// Don't display a release date (for when products can be delivered).
						availability.releaseDate = null;
						checkStockMap = false;
					}
					// Set if gift card or not
					this.isDownload = stockMap['download'] > 0;
					// Special logic for digital downloads.
					if (this.selectedShippingMethodId === 5) {
						availability.inDigitalStock = stockMap['download'] > 0;
					}

					const deliveryInfo = stockUtils.timeToWebStockDelivery(stockMap);
					let days = null;
					// Estimated number of days until product is in stock at CL.
					if (deliveryInfo && deliveryInfo.days) {
						days = deliveryInfo.days;
					}

					const shipFromStore = [];
					for (const store in stockMap) {
						if (! isNaN(store) && parseInt(Number(store)) == store && ! isNaN(parseInt(store, 10))) {
							shipFromStore.push(parseInt(store))
						}
						availability.shipFromStore = shipFromStore;
						const storeId = store + '';
						const inStockInStore = stockMap[storeId] >= qty;
						availability.inStockInStore = inStockInStore;
						if (storeId === 'web' && inStockInStore && availability.inWebStock === undefined) {
							// Product is in stock and availability has not been set yet.
							availability.inWebStock = !!(this.shippingSiteInfo.hasStock?.length || this.shippingSiteInfo.involvesShipFromStore);
						} else if (storeId === 'web' && !inStockInStore && days) {
							// We have an estimated number of days when the product
							// will be in stock in CL.
							availability.inWebStock = false;
							if (!availability.estimateDays) {
								// Initialize the estimate days array.
								availability.estimateDays = [0, 0];
							}
							// Update estimate (the product with the longest esitmated
							// delivery time will determine the estimate).
							if (days[0] > availability.estimateDays[0]) {
								availability.estimateDays[0] = days[0];
							}
							if (days[1] > availability.estimateDays[1]) {
								availability.estimateDays[1] = days[1];
							}
						} else if (storeId === 'web' && ! inStockInStore && ! days) {
							// Not in web stock!
							availability.inWebStock = false;
							availability.estimateDays = null;
							// Don't display a release date (for when products can be delivered).
							availability.releaseDate = null;
							checkElseIf = false;
						}
					}
				}
			}
			return availability;
		},
		shippingPriceMap () {
			let map = {};

			this.imiGoShippingMethods.forEach(shippingMethod => {
				map[shippingMethod.id] = shippingMethod.price;
			});

			return map;
		},
		cart () {
			if (this.predefinedCart) {
				return this.predefinedCart;
			}
			return this.$store.state.cart;
		},
		mostExpensiveProductInCart () {
			return getMostExpensiveProduct(this.cart);
		},
		hasEolDeliveryIssues () {
			let options = {
				deliveryOption1: false,
				deliveryOption2: false,
			}

			if (this.stockAvailability.eolRelatedDeliveryIssues.bulky.products.length
				|| this.stockAvailability.eolRelatedDeliveryIssues.shipFromStore.products.length
				|| this.stockAvailability.eolRelatedDeliveryIssues.cantShip.products.length
				|| this.stockAvailability.eolRelatedDeliveryIssues.outOfStock.products.length
			) {
				options.deliveryOption2 = true;
			}

			if (this.stockAvailability.eolRelatedDeliveryIssues.specificStorePickup.products.length) {
				options.deliveryOption1 = true;
			}

			return options;
		},
		...mapGetters({
			/*shippingDiscount: 'user/shippingDiscount',*/
			isLoggedIn: 'user/isLoggedIn',
			rankLevel: 'user/rankLevel',
		}),
		...mapState({
			user: state => state.user,
			imiGoShippingMethodsMap: state => state.shippingMethodRelatedInfo.imiGoShippingMethodsMap,
			splittableShippingOptions: state => state.shippingMethodRelatedInfo.splittableShippingOptions,
			fromStoreShipmentOptions: state => state.shippingMethodRelatedInfo.fromStoreShipmentOptions,
			shippingStoresByPrioOrder: state => state.shippingMethodRelatedInfo.shippingStoresByPrioOrder,
			hasUnrestrictedShipping: state => state.shippingMethodRelatedInfo.hasUnrestrictedShipping,
			reSupplyPointId: state => state.shippingMethodRelatedInfo.reSupplyPointId,
			horizonEnabled: state => state.shippingMethodRelatedInfo.horizonEnabled,
			eolFromStoreShipmentEnabled: state => state.shippingMethodRelatedInfo.eolFromStoreShipmentEnabled,
		}),
		getDeliveryText () {
			if (this.deliveryOption === 1) {
				return 'Välj Butik';
			} else if (this.deliveryOption === 2) {
				return 'Välj Fraktsätt';
			} else {
				return 'Välj Butik/fraktsätt';
			}
		},
		useSubtitle () {
			if (this.deliveryOption === 0 || ! this.isActive) {
				return true;
			} else {
				return false;
			}
		},
		useBackgroundColor () {
			if (! this.firstTimeDisplay || ! this.isActive && this.deliveryOption < 1 || ! this.isActive && (this.selectedShippingMethodId < 1 && this.selectedStoreId < 1) || this.activeStep < 2) {
				return true;
			} else {
				return false;
			}
		},
		showContinueButton () {
			if (this.isActive) {
				if (this.deliveryOption === 1 && this.selectedStoreId) {
					if (this.stockAvailability.eolRelatedDeliveryIssues.specificStorePickup.products.length) {
						let canContinue = true;
						this.stockAvailability.eolRelatedDeliveryIssues.specificStorePickup.products.forEach((product) => {
							if (! this.shippingSiteInfo.eolStockPlaces[product].includes(this.selectedStoreId.toString())) {
								canContinue = false;
							}
						});
						return canContinue;
					} else {
						return true;
					}
				} else if (this.deliveryOption === 2 && this.selectedShippingMethodId && this.selectedZipCode ) {
					return ! this.hasEolDeliveryIssues.deliveryOption2;
				} else {
					return false;
				}
			}
			return false;
		},
		partialDeliveryAvailable () {
			return this.deliveryOption !== 1 && this.activeStep > 1 && ! this.stockAvailability.inWebStock && this.cart.rows.length > 1 && this.orderTotalSum >= 598;
		},
		numberOfProductsSentFromStore () {
			return this.cart.rows.reduce((acc, curr) => acc + (curr.product.stock.isSentFromStore !== 0 || 0), 0);
		},
		isAllProductsSentFromStore () {
			return this.numberOfProductsSentFromStore === this.cart.rows.length ? true : false;
		},
		canShipNow () {
			if (this.numberOfProductsSentFromStore > 0 && this.stockAvailability?.shipFromStore?.length) {
				for (const store of this.stockAvailability.shipFromStore) {
					const allExistsInSameStore =  this.cart.rows.every((curr) => {
						const quantity = curr.quantity;
						const stock = curr.product.stock[store];

						return stock >= quantity;
					});
					if (allExistsInSameStore) {
						return true;
					}
				}
				return false;
			}
			return this.stockAvailability.inWebStock;
		},
		showShipFromStorePopup () {
			return this.numberOfProductsSentFromStore > 0 && ! this.isDownload && this.stockAvailability.inStockInStore;
		}
	},
	watch: {
		cart: {
			handler (to, frm) {
				this.debouncedGetShippingMethods();
			},
			deep: true,
		},
		selectedZipCode (to, frm) {
			if (to !== frm && frm !== 0) {
				this.$emit('update:selectedStoreId', null);
			}
		},
		isActive (to, frm) {
			if (to) {
				this.firstTimeDisplay = true;
			}
		},
		activeStep (to) {
			if (to === 1) {
				this.deliveryOption = 0;
				this.$emit('storeReservationUpdated', null);
			}
		},
		/* Watches store change */
		storeStock (to) {
			if (this.deliveryOption === 1) {
				this.$emit('stockAvailability', !! to || (this.stockAvailability.inWebStock && ! this.stockAvailability.releaseDate));
			}
		},
		/* Watches the stock change, depending on changes to quantity in cart */
		stockAvailability (to) {
			if (this.deliveryOption === 2) { // Delivery
				this.$emit('stockAvailability', to.inWebStock && ! to.releaseDate);
			} else if (this.deliveryOption === 1) { // Store
				this.$emit('stockAvailability', !! this.storeStock || (to.inWebStock && ! to.releaseDate));
			}
		},
		stepSelection (to) {
			if (to) {
				this.$emit('stepSelection', { 2: to });
			}
		},
		isCorporateCustomer (to, frm) {
			if (to !== frm) {
				this.imiGoShippingMethods = [];
			}
		},
		shippingSiteInfo (to) {
			localSessionStorage.set('checkout:shippingSiteId', to.shippingSiteId);
			this.$emit('update:shippingSiteInfo', to);
		},
		isLoggedIn (to, frm) {
			if (to && ! frm) {
				this.debouncedGetShippingMethods();
			}
		},
		waitForBriqpay (to, frm) {
			if (to && ! frm) {
				this.returningFromBriqpay = false;
				this.debouncedGetShippingMethods();
			}
		},
	},
};
</script>
